import { invoice } from '@tma.js/sdk-react';

/** Счёт в Telegram Stars внутри мини-приложения. true — оплачен (предмет выдаёт сервер по уведомлению бота). */
export async function payInvoice(link: string): Promise<boolean> {
  try {
    if (!invoice.openUrl.isAvailable()) return false;
    return (await invoice.openUrl(link)) === 'paid';
  } catch {
    return false;
  }
}
